// eslint-disable-next-line
export const ADDRESSES_CHANGE_ACTIVE_ADDRESS = 'ADDRESSES_CHANGE_ACTIVE_ADDRESS'

export const ADDRESS_TYPES = {
    ADA001: 'registered',
    ADA003: 'temporary',
    ADA006: 'shops',
    ADA0RP: 'branch',
    default: 'default',
}
